import { render } from "./user-show.vue?vue&type=template&id=4f554160&scoped=true"
import script from "./user-show.vue?vue&type=script&lang=js"
export * from "./user-show.vue?vue&type=script&lang=js"

import "./user-show.vue?vue&type=style&index=0&id=4f554160&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f554160"]])

export default __exports__